import { render, staticRenderFns } from "./SubSectionFooter.vue?vue&type=template&id=cbab964c"
import script from "./SubSectionFooter.vue?vue&type=script&lang=js"
export * from "./SubSectionFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports